/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { NftGatedTrackSignature } from './NftGatedTrackSignature';
import {
    NftGatedTrackSignatureFromJSON,
    NftGatedTrackSignatureFromJSONTyped,
    NftGatedTrackSignatureToJSON,
} from './NftGatedTrackSignature';
import type { VersionMetadata } from './VersionMetadata';
import {
    VersionMetadataFromJSON,
    VersionMetadataFromJSONTyped,
    VersionMetadataToJSON,
} from './VersionMetadata';

/**
 * 
 * @export
 * @interface NftGatedTrackSignaturesResponse
 */
export interface NftGatedTrackSignaturesResponse {
    /**
     * 
     * @type {number}
     * @memberof NftGatedTrackSignaturesResponse
     */
    latestChainBlock: number;
    /**
     * 
     * @type {number}
     * @memberof NftGatedTrackSignaturesResponse
     */
    latestIndexedBlock: number;
    /**
     * 
     * @type {number}
     * @memberof NftGatedTrackSignaturesResponse
     */
    latestChainSlotPlays: number;
    /**
     * 
     * @type {number}
     * @memberof NftGatedTrackSignaturesResponse
     */
    latestIndexedSlotPlays: number;
    /**
     * 
     * @type {string}
     * @memberof NftGatedTrackSignaturesResponse
     */
    signature: string;
    /**
     * 
     * @type {string}
     * @memberof NftGatedTrackSignaturesResponse
     */
    timestamp: string;
    /**
     * 
     * @type {VersionMetadata}
     * @memberof NftGatedTrackSignaturesResponse
     */
    version: VersionMetadata;
    /**
     * 
     * @type {{ [key: string]: NftGatedTrackSignature; }}
     * @memberof NftGatedTrackSignaturesResponse
     */
    data?: { [key: string]: NftGatedTrackSignature; };
}

/**
 * Check if a given object implements the NftGatedTrackSignaturesResponse interface.
 */
export function instanceOfNftGatedTrackSignaturesResponse(value: object): value is NftGatedTrackSignaturesResponse {
    let isInstance = true;
    isInstance = isInstance && "latestChainBlock" in value && value["latestChainBlock"] !== undefined;
    isInstance = isInstance && "latestIndexedBlock" in value && value["latestIndexedBlock"] !== undefined;
    isInstance = isInstance && "latestChainSlotPlays" in value && value["latestChainSlotPlays"] !== undefined;
    isInstance = isInstance && "latestIndexedSlotPlays" in value && value["latestIndexedSlotPlays"] !== undefined;
    isInstance = isInstance && "signature" in value && value["signature"] !== undefined;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "version" in value && value["version"] !== undefined;

    return isInstance;
}

export function NftGatedTrackSignaturesResponseFromJSON(json: any): NftGatedTrackSignaturesResponse {
    return NftGatedTrackSignaturesResponseFromJSONTyped(json, false);
}

export function NftGatedTrackSignaturesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): NftGatedTrackSignaturesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'latestChainBlock': json['latest_chain_block'],
        'latestIndexedBlock': json['latest_indexed_block'],
        'latestChainSlotPlays': json['latest_chain_slot_plays'],
        'latestIndexedSlotPlays': json['latest_indexed_slot_plays'],
        'signature': json['signature'],
        'timestamp': json['timestamp'],
        'version': VersionMetadataFromJSON(json['version']),
        'data': !exists(json, 'data') ? undefined : (mapValues(json['data'], NftGatedTrackSignatureFromJSON)),
    };
}

export function NftGatedTrackSignaturesResponseToJSON(value?: NftGatedTrackSignaturesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'latest_chain_block': value.latestChainBlock,
        'latest_indexed_block': value.latestIndexedBlock,
        'latest_chain_slot_plays': value.latestChainSlotPlays,
        'latest_indexed_slot_plays': value.latestIndexedSlotPlays,
        'signature': value.signature,
        'timestamp': value.timestamp,
        'version': VersionMetadataToJSON(value.version),
        'data': value.data === undefined ? undefined : (mapValues(value.data, NftGatedTrackSignatureToJSON)),
    };
}

